module.exports = __webpack_public_path__ + "img/Hybrid-D-1.ea1f2b4e.jpg";